import { render, staticRenderFns } from "./real-area.vue?vue&type=template&id=61313b05&"
import script from "./real-area.vue?vue&type=script&lang=js&"
export * from "./real-area.vue?vue&type=script&lang=js&"
import style0 from "./real-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports